import { defineBrand } from "@cfg/brand-sdk";
import { config } from "./brand.config.ts";
import { css } from "./css.ts";
import { ledger } from "./scene.ts";
import { slots } from "./slots.tsx";

export const brand = defineBrand({ config, scenes: { ledger }, slots, css });
export default brand;
